// roles-management
import SideMenu from '@/containers/side-menu/SideMenu.vue';
import RolesManagement from '@/pages/roles-management/RolesManagement.vue';

export default {
  path: '/roles-management',
  name: 'RolesManagement',
  components: {
    mainContent: RolesManagement,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'roles',
    },
    breadcrumb: {
      title: 'Gerenciamento de permissões',
      paths: [{ title: 'Cadastros' }, { title: 'Permissões' }],
    },
  },
};
